<template>
  <div class="organization-list">
    <vue-headful title="Список организаций" />

    <div class="container">
      <div class="profile-content">
        <div class="row">
          <div class="col-md-8">
            <h2>Список организаций</h2>
          </div>
          <div class="col-md-4 text-right">
            <button
              type="button"
              class="btn btn-primary"
              @click="createOrganization"
            >
              Создать организацию
            </button>
          </div>
        </div>

        <hr>

        <div class="row filters-block">
          <div class="col-sm-6 first-filter-input-block">
            <input
              v-model="searchQuery"
              type="text"
              class="form-control"
              placeholder="Поиск"
              @change="changeNameSearch($event)"
            >
          </div>
        </div>

        <div v-if="organizations && organizations.length">
          <div class="row">
            <div class="col-md-12">
              <div v-for="organization in organizations" :key="organization.id">
                <organization-list-item :organization="organization" />
              </div>
            </div>
          </div>
        </div>

        <infinite-loading :identifier="infiniteId" @infinite="infiniteLoadOrganizations">
          <div slot="no-more">Показаны все записи</div>
          <div slot="no-results">Нет записей</div>
        </infinite-loading>
      </div>
    </div>
  </div>
</template>

<script>
import mainMixin from '@/common/mixins/mainMixin'
import { ApiClient } from '@/common/helpers/api-client/ApiClient'
import OrganizationListItem from '@/common/components/Organization/OrganizationListItem.vue'

export default {
  name: 'OrganizationList',

  components: { OrganizationListItem },

  mixins: [mainMixin],

  data() {
    return {
      infiniteId: 0,
      organizations: [],
      searchQuery: '',
      pagination: {
        active: 1,
        per: 10
      },
      preloader: true,
      searchChanged: false
    }
  },

  computed: {
    filterParams() {
      return {
        searchQuery: this.searchQuery,
        page: this.pagination.active
      }
    }
  },

  async created() {
    this.pagination.active = history.state?.page ?? 1
    this.hidePreloader()

    const vue = this
    window.addEventListener('popstate', (event) => {
      if (event.state) {
        vue.fillSearchParamsFromState(event)
        vue.clearSearch(this.pagination.active)
      }
    })
  },

  methods: {
    changeNameSearch(event) {
      if (this.searchChanged) {
        return
      }

      this.searchChanged = true
      this.searchQuery = event.target.value
      this.changeSearch()
    },

    changeSearch() {
      this.insertSearchParams()
      this.clearSearch(this.pagination.active)

      setTimeout(() => {
        this.searchChanged = false
      }, 500)
    },

    async clearSearch(page) {
      this.pagination.active = page
      this.organizations = []
      this.infiniteId += 1
    },

    fillSearchParamsFromState({
      searchQuery,
      page
    }) {
      this.searchQuery = searchQuery
      this.pagination.active = page ?? 1
    },

    async getPageOrganizations(activePage, perPage = null) {
      let results = []

      await ApiClient.getOrganizationList({
        page: activePage,
        perPage: perPage || this.pagination.per,
        searchQuery: this.searchQuery
      }).then((response) => {
        results = response?.data?.data?.models || []
      })

      return results
    },

    async infiniteLoadOrganizations($state) {
      let organizations
      if (!this.organizations.length) {
        this.pagination.active = 1
        if (Object.keys(this.$route.query).length) {
          this.fillSearchParamsFromState({
            searchQuery: this.searchQuery,
            page: this.pagination.active ?? this.$route.query.page ?? 1
          })
        }
      }

      organizations = await this.getPageOrganizations(this.pagination.active)

      if (organizations?.length) {
        this.pagination.active++
        this.organizations.push(...organizations)
        $state.loaded()
      } else if (organizations?.length === 0) {
        $state.complete()
      } else {
        $state.error()
      }

      this.replaceStatePageData()
    },

    async insertSearchParams() {
      this.pagination.active = 1
      await this.$router.push({ query: { ...this.filterParams } })
    },

    replaceStatePageData() {
      const params = history.state ?? this.filterParams
      params.page = this.pagination.active

      const url = new URL(window.location)
      url.searchParams.set('page', this.pagination.active)
      history.replaceState(params, undefined, url.href)
    },

    createOrganization() {
      this.$router.push({ name: 'organization-create' })
    }
  }
}
</script>

<style scoped>
.organization-list {
  min-height: 100vh;
  background: #f0f2f7;
}

.content {
  background: #ffffff;
  border-radius: 16px;
  padding: 28px 32px;
  box-shadow:
    0 1px 3px rgba(0, 0, 0, 0.06),
    0 8px 32px rgba(0, 0, 0, 0.07);
  margin-top: 24px;
  margin-bottom: 32px;
}

.filters-block {
  margin-bottom: 14px;
}

.first-filter-input-block {
  padding-left: 0;
}

.filter-input-block {
  padding-right: 0;
}
</style>
